<div class="innerpage-fullwithbanner">
  <h2 class="bighead">
    <span *ngIf="isBuy">My Inquiries </span>
    <span *ngIf="!isBuy">Inquiries Received </span>
    <!--<span class="offerstatus">{{rowCount|number}}</span>-->
  </h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li *ngIf="isBuy">My Inquiries</li>
    <li *ngIf="!isBuy">Inquiries Received</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="border-div list-box table-fixed margin0">
          <div class="tabstyle2 offerdetailstab-padding pos-relative" *ngIf="isBuy">
            <ul class="switchingproperty margin-bottom-15 offerlistingtab">
              <li [class.active]="currentTab === tabs.Inquiries">
                <a href="javascript:void(0);" (click)="onTabClick(tabs.Inquiries)">
                  Inquiries
                  <!--<span *ngIf="currentTab === tabs.Inquiries;" class="countstyle">{{rowCount}}</span>-->
                </a>
              </li>
              <li [class.active]="currentTab === tabs.Inquiries1031">
                <a href="javascript:void(0);" (click)="onTabClick(tabs.Inquiries1031)">
                  1031 Inquiries
                  <!--<span *ngIf="currentTab === tabs.Inquiries1031;" class="countstyle">{{exchange1031Count}}</span>-->
                </a>
              </li>
            </ul>
            <!--<div class="absolutesearch">
                <div class="floatinghead clearfix">
                    <div class="rightside clearfix">
                        <div class="search-sec ">
                            <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                            <i class="fa fa-search icon" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>-->
          </div>
          <div *ngIf="currentTab === tabs.Inquiries">
            <div class="floatinghead clearfix">
              <div class="rightside clearfix">
                <div class="search-sec">
                  <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                  <i class="fa fa-search icon" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table basictable my-inquiry-table row-border hover" datatable [dtOptions]="dtOptions" style="border-collapse:collapse;">
                <thead>
                  <tr>
                    <th class="min-width-td">Tenant</th>
                    <th [hidden]="isBuy">Prospect</th>
                    <th [hidden]="brokerDisable1031Prioncipal">Broker</th>
                    <th>Comments</th>
                    <th>Date of Inquiry</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let offer of offers; let i = index ">
                    <td>
                      <p style="max-width:160px;">
                        <a *ngIf="!offer.IsArchive || (authService.Broker() || authService.Admin()||authService.SuperAdmin())" href="javascript:void(0);" routerLink="/viewproperty/{{offer.Slug ? offer.Slug : offer.PGuid}}" [queryParams]="{'prevroute':'My Inquiries',link:router.url}">{{ offer.TenantName }}</a>
                        <a *ngIf="offer.IsArchive && !authService.Broker() && !authService.Admin()&&!authService.SuperAdmin()" href="javascript:void(0);" (click)="archivepropertyMessage()">{{ offer.TenantName }}</a>

                      </p>
                    </td>
                    <td [hidden]="isBuy">
                      <p>{{ offer.LeadName }}</p>
                      <p *ngIf="offer.LeadPhone">{{ offer.LeadPhone | phone }}</p>
                      <p *ngIf="offer.LeadEmail">{{offer.LeadEmail}}</p>
                    </td>
                    <td [hidden]="brokerDisable1031Prioncipal">
                      <p>{{ offer.PrimaryContactName }}</p>
                      <p *ngIf="offer.SecondaryContactNames">{{ offer.SecondaryContactNames }}</p>
                    </td>
                    <td>
                      <p class="ellipsis-text commentpara">
                        {{offer.Comments?.length > 15 ? (offer.Comments.substr(0,15) + '...') :  (offer.Comments ? (offer.Comments):'-')}}
                        <a *ngIf="offer.Comments?.length > 15 " href="javascript:void(0)" class="blue-text view-text" container="body" triggers="focus" popover="{{offer.Comments}}"><span>View More</span></a>
                      </p>
                    </td>
                    <td><span *ngIf="offer.InquiryDate">{{convertUTCDateToLocalDate(offer.InquiryDate)| date:'MM/dd/yyyy'}}</span></td>
                    <td><span class="status-blue">{{offer.StatusName}}</span></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr *ngIf="offers?.length == 0 &&!IsLoading">
                    <td colspan="6" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div *ngIf="currentTab === tabs.Inquiries1031">
            <app-my1031-inquiry-list></app-my1031-inquiry-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Inquiry Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete  ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteInquiry();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>
